<template>
    <li class="nav-item">
        <a
            class="btn btn-success"
            @click="sendQuickMessage"
						v-bind:class="{'disabled': !canSendMessage}"
        >
            NEW MESSAGE
        </a>
    </li>
</template>

<script>
  import eventBus from "../event-bus";

  export default {
		props: {
			canSendMessage: Boolean,
		},

    data() {
      return {
        //
      };
    },

    methods: {
      /**
       * @return {undefined}
       */
      sendQuickMessage() {
        eventBus.$emit('show-quick-chat-message');
      },
    },

  }
</script>
